import { RegisterData } from "@/types/auth";
import { config } from "../config";
import { getBaseHeaders, handleApiError } from "./utils";
import { setUserId } from "./validation";
import { normalizeEmail } from "@/utils/emailUtils";
import { isNative } from "@/utils/platform";

export const register = async (userData: RegisterData) => {
  try {
    const normalizedUserData = {
      ...userData,
      email: normalizeEmail(userData.email),
    };

    const fetchInit: RequestInit = {
      method: 'POST',
      headers: getBaseHeaders(),
      body: JSON.stringify(normalizedUserData),
    };

    if (!isNative()) {
      fetchInit.credentials = 'include';
    }

    const response = await fetch(`${config.API_URL}/user/register`, fetchInit);

    if (!response.ok) {
      await handleApiError(response, 'Registration');
    }

    const data = await response.json();

    if (data && data.user_id) {
      setUserId(data.user_id);
    }

    return data;
  } catch (error) {
    throw error;
  }
};
